import React, { useState } from "react";
import "./Know_Your_Plan.css";
import RedRoundBtn from "../../Common_Btn/RedRoundBtn/RedRoundBtn";
import { Modal, ProgressBar } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTimesCircle,
  faCheckCircle,
  faTimes,
  faThumbsUp,
  faUmbrella,
  faCaretUp,
  faTrophy,
  faLocationPin,
} from "@fortawesome/free-solid-svg-icons";
import Gray_btn from "../../Common_Btn/Gray_btn/Gray_btn";
import Insurer_cards from "./Insurer_cards/Insurer_cards";
import Logo_holder from "./Logo_holder/Logo_holder";

function Know_Your_Plan({ val, ...props }) {
  const [step, setStep] = useState(1); // Current step state
  const [subStep, setSubStep] = useState(1); // Sub-step for step 3
  const totalSteps = 3;
  const progress = (step / totalSteps) * 100; // Calculate progress percentage

  // Function to go to the next step
  const handleNext = () => {
    if (step === 3 && subStep === 1) {
      setSubStep(2); // Move to "Paid Benefit (2/2)" in Step 3
    } else if (step < totalSteps) {
      setStep(step + 1);
      setSubStep(1); // Reset subStep when moving to the next step
    } else {
      props.onHide(); // Close modal on the last step
    }
  };

  // Function to go to the previous step
  const handlePrev = () => {
    if (step === 3 && subStep === 2) {
      setSubStep(1); // Go back to "Paid Benefit (1/2)"
    } else if (step > 1) {
      setStep(step - 1);
      setSubStep(1); // Reset subStep when moving back a step
    }
  };

  const stepNames = [
    "Plan Benefits",
    "Free Benefit",
    "Paid Benefit",
    // "About Insurer",
  ];

  console.log(val, "val val");

  return (
    <>
      <section className="Know_Your_Plan">
        <Modal
          {...props}
          size="xl"
          className="Know_Your_Plan"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header>
            <FontAwesomeIcon
              onClick={props.onHide}
              className="close_icon"
              icon={faTimesCircle}
            />
          </Modal.Header>

          <Modal.Body>
            {/* Progress Bar */}
            <div className="progress-container">
              <div className="progress_bar_holder">
                <ProgressBar
                  now={(step - 1) * (100 / (totalSteps - 1))} // Adjust fill to step name position
                  max={100}
                  className="progressbar_holder"
                  variant="danger"
                  style={{
                    height: "5px",
                    borderRadius: "5px",
                    backgroundColor: "#EEF3FF", // Light background for unfilled parts
                  }}
                />

                {/* Moving Step Indicator (Step Number Only) */}
                <span
                  className="step-indicator"
                  style={{
                    position: "absolute",
                    left: `calc(${(step - 1) *
                      (100 / (totalSteps - 1))}% - 15px)`, // Adjust position dynamically
                    transition: "left 0.3s ease-in-out",
                  }}
                >
                  {step}/{totalSteps}
                </span>
              </div>

              {/* Step Labels Positioned Correctly */}
              <div className="step_name_holder">
                {stepNames.map((name, index) => (
                  <span
                    key={index}
                    className={`step-label ${
                      index + 1 === step ? "active-step" : ""
                    }`}
                    style={{
                      left: `${(index * 100) / (totalSteps - 1)}%`,
                      transform: "translateX(-50%)",
                    }}
                  >
                    {name}
                  </span>
                ))}
              </div>
            </div>

            {/* Step 1: Plan Overview */}
            {step === 1 && (
              <>
                <div className="form_field_holder">
                  <h2 className="plan-title">Your Plan</h2>
                  <p className="plan-description">{val?.about_plane}</p>
                </div>

                <div className="form_field_holder">
                  <p className="text_holder">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="icon green"
                    />
                    <span> Inclusions : </span> {val?.what_cover}
                  </p>
                </div>

                <div className="form_field_holder">
                  <p className="text_holder">
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      className="icon red"
                    />
                    <span>Exclusions : </span>{" "}
                    <strong>{val?.what_not_cover}</strong>
                  </p>
                </div>
              </>
            )}

            {/* Step 2: Inclusions */}
            {step === 2 && (
              <>
                <div className="form_field_holder">
                  <h2 className="plan-title">Free Benefits</h2>
                </div>

                {/* <div className="form_field_holder">
                  <h2 className="plan-subtitle">
                    <div className="icon_holder">
                      <img
                        className="icon_img"
                        src={
                          process.env.PUBLIC_URL +
                          "/assets/Image/Know_Your_Plan/icon/tax_benefits.png"
                        }
                        alt="icon_img"
                      />
                    </div>
                    Tax Benefits
                  </h2>
                  <p className="text_holder">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="icon gray"
                    />
                    All Premiums paid upto 1.5 Lac a year are exempted from tax
                    under section 80C
                  </p>
                  <p className="text_holder">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="icon gray"
                    />
                    In case of your death the life cover paid to your nominee is
                    completely tax free under section 10(10D)
                  </p>
                </div> */}

                {val?.f_i_add_ons
                  ?.filter((addOn) => addOn.type === "Free")
                  .map((val1) => (
                    <div className="form_field_holder">
                      <h2 className="plan-subtitle">
                        <div className="icon_holder">
                          <img
                            className="icon_img"
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/Image/Know_Your_Plan/icon/0_percent.png"
                            }
                            alt="icon_img"
                          />
                        </div>
                        {val1?.name}
                      </h2>
                      <p className="text_holder">{val1?.description}</p>
                    </div>
                  ))}
              </>
            )}

            {/* Step 3: Paid Benefits with Sub-Steps */}
            {/* {step === 3 && subStep === 1 && ( */}
            {step === 3 && (
              <div>
                <div className="form_field_holder">
                  <h2 className="plan-title">
                    Paid Benefit
                    {/* <span>(1/2)</span> */}
                  </h2>
                </div>

                {/* <div className="form_field_holder">
                  <h2 className="plan-subtitle">
                    Accidental Total Permanent Disability Benefit
                  </h2>
                  <p className="text_holder">
                    One death every minute in India happens due to a road
                    accident. 24% of the road accidents have been fatal over the
                    last 5 years.
                  </p>
                  <p className="text_holder">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      className="icon gray"
                    />
                    This benefit provides additional coverage up to twice the
                    life cover at a nominal price when death occurs due to an
                    accident.
                  </p>
                </div> */}
                {val?.f_i_add_ons
                  ?.filter((addOn) => addOn.type === "Paid")
                  .map((val1) => (
                    <div className="form_field_holder">
                      <h2 className="plan-subtitle">{val1?.name}</h2>
                      <p className="text_holder">
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className="icon gray"
                        />
                        {val1?.description}
                      </p>
                      {/* <p className="text_holder">
                        <FontAwesomeIcon
                          icon={faCheckCircle}
                          className="icon gray"
                        />
                        Base life cover is also paid out.
                      </p> */}
                    </div>
                  ))}

                <div className="note_holder">
                  <div className="icon_holder">
                    <FontAwesomeIcon className="thumb_icon" icon={faThumbsUp} />
                  </div>
                  Recommended for people who travel regularly. Also, very cost
                  effective for younger people (Most deaths at younger ages tend
                  to occur due to accidents and the cover comes at a very low
                  cost)
                </div>
              </div>
            )}

            {/* {step === 3 && subStep === 2 && (
              <div>
                <div className="form_field_holder">
                  <h2 className="plan-title">
                    Paid Benefit <span>(2/2)</span>
                  </h2>
                </div>

                <div className="form_field_holder">
                  <h2 className="plan-subtitle">
                    Accidental Total Permanent Disability Benefit
                  </h2>
                  <p className="text_holder">
                    In the event of total permanent disability due to accident,
                    you will receive a lump sum amount. This helps cover
                    expenses and income loss.
                  </p>
                </div>

                <div className="form_field_holder">
                  <h2 className="plan-subtitle">
                    What is Total Permanent Disability?
                  </h2>
                  <p className="text_holder">
                    It means the insured person is either unable to work or is
                    physically impaired (loss of both limbs, loss of sight of
                    both eyes etc.) The disabilities continue without
                    interruption for a six months period & must be deemed
                    permanent via medical practitioner.
                  </p>
                </div>

                <div className="note_holder">
                  <div className="icon_holder">
                    <FontAwesomeIcon className="thumb_icon" icon={faThumbsUp} />
                  </div>
                  Recommended for people who travel regularly.
                </div>
              </div>
            )} */}

            {/* Step 4: Final Confirmation */}
            {step === 4 && (
              <>
                <div className="form_field_holder">
                  <h2 className="plan-title">About Insurer</h2>
                  <p className="plan-description">
                    Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                    Error, incidunt voluptates. Eligendi nesciunt dolorum
                    reprehenderit fugiat perspiciatis, animi tempora aut.
                  </p>
                </div>

                <div className="form_field_holder">
                  <div className="row">
                    <div className="col-xl-3 col-lg-4 col-md-6">
                      <div className="Insurer_cards_holder">
                        <Insurer_cards
                          className={"orange_icon"}
                          icon={faCaretUp}
                          priceText={"₹ 11,123 Cr"}
                          infoText={"Lorem, ipsum dolor."}
                          financeYear={"As Compared FY 2022- 23"}
                        />
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-6">
                      <div className="Insurer_cards_holder">
                        <Insurer_cards
                          className={"orange_icon"}
                          icon={faCaretUp}
                          priceText={"₹ 11,123 Cr"}
                          infoText={"Lorem, ipsum dolor."}
                          financeYear={"As Compared FY 2022- 23"}
                        />
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-6">
                      <div className="Insurer_cards_holder">
                        <Insurer_cards
                          className={"orange_icon"}
                          icon={faCaretUp}
                          priceText={"₹ 1,11,253 Cr"}
                          infoText={"Lorem, ipsum dolor."}
                          financeYear={"As Compared FY 2022- 23"}
                        />
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-6">
                      <div className="Insurer_cards_holder">
                        <Insurer_cards
                          className={"blue_icon"}
                          icon={faUmbrella}
                          priceText={"21%"}
                          infoText={"Lorem, ipsum dolor."}
                        />
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-6">
                      <div className="Insurer_cards_holder">
                        <Insurer_cards
                          className={"blue_icon"}
                          icon={faTrophy}
                          priceText={"11%"}
                          infoText={"Lorem, ipsum dolor."}
                        />
                      </div>
                    </div>

                    <div className="col-xl-3 col-lg-4 col-md-6">
                      <div className="Insurer_cards_holder">
                        <Insurer_cards
                          className={"blue_icon"}
                          icon={faLocationPin}
                          priceText={"458"}
                          infoText={"Lorem, ipsum dolor."}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="insurer_logo_holder">
                    <Logo_holder />

                    <Logo_holder />

                    <Logo_holder />
                  </div>
                </div>
              </>
            )}
          </Modal.Body>

          {/* Navigation Buttons */}
          <Modal.Footer>
            {(step > 1 || subStep > 1) && (
              <Gray_btn onClick={handlePrev} btn_name={"Back"} />
            )}
            <RedRoundBtn
              onClick={handleNext}
              btn_name={step === totalSteps ? "Done" : "Next"}
            />
          </Modal.Footer>
        </Modal>
      </section>
    </>
  );
}

export default Know_Your_Plan;
